module.exports = "<div class=\"modal-header-activation\">\n  <h3 ng-if=\"title\">{{ title }}</h3> \n  <p ng-if=\"subtitle\">{{ subtitle }}</p> \n</div>\n<footer>\n    <button class=\"button\" ng-click=\"okFunc()\"> {{ \"services.activations.buttons.activate.modal.button\" | translate}} </button>\n</footer>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/store/storeAdd/storeCreateSuccess.html
 ** module id = 463
 ** module chunks = 0
 **/